export default {
  list: {
    title: 'Palavras',
    subtitle: 'Lista',
    add: 'Nova palavra',
  },
  create: {
    title: 'Adicionar',
    subtitle: 'Palavras',
  },
  importPage: {
    title: 'Importar',
    subtitle: 'Palavras',
  },
  importList: {
    title: 'Importação de Palavras',
    subtitle: 'Histórico',
    add: 'Importar palavras',
    cardTitle: 'Histórico de Importações',
    searchPlaceholder: 'Procurar por arquivo...',
  },
  importForm: {
    cardTitle: 'Importar Arquivo (.txt)',
    actions: 'Ações',
  },
  edit: {
    subtitle: 'Banco de Perguntas',
    questionsTitle: 'Perguntas',
    addQuestion: 'Nova Pergunta',
    levelFilter: 'Filtro por nível',
  },
  table: {
    title: 'Palavras Ativos',
    searchPlaceholder: 'Procurar por algo...',
    exportTxt: 'Exportar em .txt',
    noContent: 'Ainda não tem nenhuma palavra cadastrada.',
    columns: {
      name: 'Nome',
      options: 'Opções',
    },
  },
  importTable: {
    columns: {
      date: 'Data',
      file: 'Arquivo',
      user: 'Usuário',
      totalRead: 'Total Lidas',
      inserted: 'Inseridas',
      options: 'Opções',
    },
    system: 'Sistema',
    hide: 'Ocultar',
    viewWords: 'Ver Palavras',
    newWordsImported: 'palavras novas importadas:',
    noContent: 'Nenhum histórico de importação encontrado.',
  },
  form: {
    word: {
      label: 'Palavra:',
      placeholder: 'Escreva a palavra',
      invalid: 'Este campo é obrigatório',
    },
  },
  question: {
    columns: {
      question: 'Pergunta',
      level: 'Nível',
      options: 'Opções',
    },
    empty: 'Nenhuma pergunta cadastrada.',
    addFirst: 'Adicionar a primeira',
    placeholder: 'Escreva a pergunta aqui...',
  },
  delete: {
    title: 'Confirme exclusão da palavra',
    message: 'Tem certeza que deseja excluir esta palavra?',
    questionTitle: 'Excluir Pergunta',
    questionMessage:
      'Tem certeza que deseja excluir esta pergunta do sistema permanentemente?',
  },
  alert: {
    saved: 'Palavra salva com sucesso!',
    deleted: 'Palavra deletada com sucesso',
    downloadSuccess: 'Download finalizado com sucesso!',
    importSuccess: '{inserted} palavras inseridas de {total}!',
    importError: 'Erro ao importar arquivo.',
    invalidFileFormat: 'O formato do arquivo deve ser .txt',
    loadWordError: 'Erro ao carregar a palavra',
    questionDeleted: 'Pergunta excluída!',
    questionDeleteError: 'Erro ao deletar.',
    questionUpdated: 'Pergunta atualizada!',
    questionCreated: 'Pergunta cadastrada!',
    questionSaveError: 'Erro ao salvar a pergunta.',
  },
};
